import { AccountLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { profileUrlFragment } from "@/components/account/utils"

export const ItemOwnersTableRowFragment = graphql(
  `
    fragment ItemOwnersTableRow on ItemOwnership {
      owner {
        ...AccountLockup
        ...profileUrl
      }
      quantity
    }
  `,
  [AccountLockupFragment, profileUrlFragment],
)
